import Box from "@mui/material/Box";
import { useEffect, useState, useContext } from "react";
import { VehicleTsSearchFilterAndSearch } from "./VehicleTsSearchFilterAndSearch";
import { vehicleTsSearchActions } from "../../service/vehicleTsSearchActions";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import { Card, Chip, IconButton, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { IServerSideGetRowsParams } from "ag-grid-community";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";
import FileSaver from "file-saver";

export const VehicleTsSearchTable = () => {
  const userImportTracking = vehicleTsSearchActions();
  const vehicleTsSearch = vehicleTsSearchActions();
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { t } = useTranslation(["operation"]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [length, setLength] = useState<number>(0);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [gridApi, setGridApi] = useState<any>(null);

  const [resetFormValueImportTracking, setResetFormValueImportTracking] = useState<boolean>(false);
  const [
    dataFormSearchFieldImportTracking,
    setDataFormSearchFieldImportTracking,
  ] = useState<any>({
    creationDateFrom: null,
    creationDateTo: null,
    //supplier: null,
    packageCode: "",
    processingStatus: null,
    voucherNumber: "",
    vin: "",
    imei: "",
  });

  const columnDefs: any = [
    {
      field: "vin",
      headerName: t("vehicleTsSearch.vin"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => VinColumn(cellValues),
    },
    {
      field: "voucherNumber",
      headerName: t("vehicleTsSearch.voucherNumber"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => VoucherNumberColumn(cellValues),
    },
    {
      field: "imei",
      headerName: t("vehicleTsSearch.imei"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => ImeiColumn(cellValues),
    },
    {
      field: "packageCode",
      headerName: t("vehicleTsSearch.packageCode"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => PackageCodeNumberColumn(cellValues),
    },
    {
      field: "creationDate",
      headerName: t("vehicleTsSearch.creationDate"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => creationDateColumn(cellValues),
    },
    /*{
      field: "supplier",
      headerName: t("vehicleTsSearch.supplier"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => SupplierColumn(cellValues),
    },*/
    {
      field: "processingStatus",
      headerName: t("vehicleTsSearch.processingStatus"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => ProcessingStatusColumn(cellValues),
    },
    {
      field: "failureReason",
      headerName: t("vehicleTsSearch.failureReason"),
      flex: 1.0,
      cellRenderer: (cellValues: any) => FailureReasonColumn(cellValues),
    },
  ];

  // LPP-25913: motivo leggibile del FAILED (etichetta tradotta della failure_reason)
  // con il dettaglio puntuale (array errors, es. messaggio del result code) nel tooltip.
  const FailureReasonColumn = (cellValues: any) => {
    const reason = cellValues.value;
    const rowErrors: string[] = Array.isArray(cellValues.data?.errors)
      ? cellValues.data.errors
      : [];
    if (!reason && rowErrors.length === 0) {
      return <Box> </Box>;
    }
    const label = reason
      ? t(`vehicleTsSearch.failureReasonType.${reason}`)
      : t("vehicleTsSearch.failureReasonType.GENERIC");
    const detail = rowErrors.join(" | ");
    const content = (
      <Box component="span" width="inherit" height="inherit">
        {label}
      </Box>
    );
    return detail ? (
      <Tooltip title={detail} arrow>
        {content}
      </Tooltip>
    ) : (
      content
    );
  };

  const creationDateColumn = (cellValues: any) => {
    return (
      // <Stack direction="row"
      //            fontWeight={400}
      //            height={'inherit'}
      //           fontSize={10}
      //            alignItems="center">
      //   {dayjs(`${cellValues.data.creationDate}`).format("DD/MM/YYYY-HH:mm")}
      // </Stack>
      <>
        {cellValues.data.creationDate ? (
          <Box component="span" width="inherit" height="inherit">
            {dayjs(cellValues.data.creationDate).format("DD/MM/YYYY-HH:mm")}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };

  const ProcessingStatusColumn = (cellValues: any) => {
    switch (cellValues.value) {
      case "PROCESSED":
        return (
          <Chip
            label={t("vehicleTsSearch.statusType.processed")}
            variant="filled"
            color="success"
          />
        );
      case "PROCESSING":
        return (
          <Chip
            label={t("vehicleTsSearch.statusType.processing")}
            variant="filled"
            color="warning"
          />
        );
      case "FAILED":
        return (
          <Chip
            label={t("vehicleTsSearch.statusType.failed")}
            variant="filled"
            color="error"
          />
        );
      default:
        return "";
    }
  };

  /*
  const SupplierColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.supplier ? (
          <Box component="span" width="inherit" height="inherit">
            {cellValues.data.supplier}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };
  */

  const PackageCodeNumberColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.packageCode ? (
          <Box component="span" width="inherit" height="inherit">
            {cellValues.data.packageCode}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };

  const VoucherNumberColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.voucherNumber ? (
          <Box component="span" width="inherit" height="inherit">
            {cellValues.data.voucherNumber}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };

  const VinColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.vin ? (
          <Box component="span" width="inherit" height="inherit">
            {cellValues.data.vin}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };

  const ImeiColumn = (cellValues: any) => {
      return (
        <>
          {cellValues.data.imei ? (
            <Box component="span" width="inherit" height="inherit">
              {cellValues.data.imei}
            </Box>
          ) : (
            <Box> </Box>
          )}
        </>
      );
    };

  const SearchImportTracking = () => {
    let vin = !!dataFormSearchFieldImportTracking.vin
      ? dataFormSearchFieldImportTracking.vin.trim()
      : null;

    let imei = !!dataFormSearchFieldImportTracking.imei
      ? dataFormSearchFieldImportTracking.imei.trim()
      : null;

    let voucherNumber = !!dataFormSearchFieldImportTracking.voucherNumber
      ? dataFormSearchFieldImportTracking.voucherNumber.trim()
      : null;

    let packageCode = !!dataFormSearchFieldImportTracking.packageCode
      ? dataFormSearchFieldImportTracking.packageCode.trim()
      : null;

    let creationDateFrom = dayjs(
      dataFormSearchFieldImportTracking?.creationDateFrom
    ).isValid()
      ? dayjs
        .utc(dataFormSearchFieldImportTracking?.creationDateFrom)
      : null;

    let creationDateTo = dayjs(
      dataFormSearchFieldImportTracking?.creationDateTo
    ).isValid()
      ? dayjs
        .utc(dataFormSearchFieldImportTracking?.creationDateTo)
      : null;

    let processingStatus = !!dataFormSearchFieldImportTracking.processingStatus
      ? [dataFormSearchFieldImportTracking.processingStatus.trim()]
      : null;

    /*
    let supplier = !!dataFormSearchFieldImportTracking.supplier
      ? dataFormSearchFieldImportTracking.supplier.trim()
      : null;
    */

    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        setIsLoading(true);
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;

        vehicleTsSearch
          .getImportTrackingFilters(
            pageNumber,
            pageSize,
            vin,
            imei,
            voucherNumber,
            packageCode,
            creationDateFrom,
            creationDateTo,
            processingStatus,
            // supplier,
          )
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.data.totalElements
            );
            if (length <= response.data.vehicleTsList.length) {
              setLength(response.data.vehicleTsList.length);
            }
            setIsLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
            }
          });
      },
    };
  };

  const exportDataImportTracking = async () => {
    setIsLoading(true);
    let vin = !!dataFormSearchFieldImportTracking.vin
      ? dataFormSearchFieldImportTracking.vin.trim()
      : null;

    let imei = !!dataFormSearchFieldImportTracking.imei
      ? dataFormSearchFieldImportTracking.imei.trim()
      : null;

    let voucherNumber = !!dataFormSearchFieldImportTracking.voucherNumber
      ? dataFormSearchFieldImportTracking.voucherNumber.trim()
      : null;

    let packageCode = !!dataFormSearchFieldImportTracking.packageCode
      ? dataFormSearchFieldImportTracking.packageCode.trim()
      : null;

    let creationDateFrom = dayjs(
      dataFormSearchFieldImportTracking?.creationDateFrom
    ).isValid()
      ? dayjs
        .utc(dataFormSearchFieldImportTracking?.creationDateFrom)
      : null;

    let creationDateTo = dayjs(
      dataFormSearchFieldImportTracking?.creationDateTo
    ).isValid()
      ? dayjs
        .utc(dataFormSearchFieldImportTracking?.creationDateTo)
      : null;

    let processingStatus = !!dataFormSearchFieldImportTracking.processingStatus
      ? dataFormSearchFieldImportTracking.processingStatus.trim()
      : null;

    userImportTracking
      .exportDataImportTracking(
        vin,
        imei,
        voucherNumber,
        packageCode,
        creationDateFrom,
        creationDateTo,
        processingStatus,
      )
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, filename);
      });
  };

  function managerData(response: any) {
    let rows: any[] = [];
    response.data.vehicleTsList.forEach((element: any) => {
      let row = {
        creationDate: element.creationDate,
        //supplier: element.supplier,
        packageCode: element.packageCode,
        processingStatus: element.processingStatus,
        voucherNumber: element.voucherNumber,
        vin: element.vin,
        imei: element.imei,
        failureReason: element.failureReason,
        errors: element.errors
      };
      rows.push(row);
    });
    return rows;
  }

  const resetFormTextImportTracking = () => {
    setDataFormSearchFieldImportTracking({
      creationDateFrom: null,
      creationDateTo: null,
      //supplier: null,
      packageCode: "",
      processingStatus: null,
      voucherNumber: "",
      vin: "",
      imei: "",
    });

    setResetFormValueImportTracking(!resetFormValueImportTracking);
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(SearchImportTracking());
    }
  }, [gridApi, resetFormValueImportTracking]);

  return (
    <>
      <SectionHeader
        title={t("vehicleTsSearch.titleFirst") + " " + t("vehicleTsSearch.titleSecond")}
      />
      <VehicleTsSearchFilterAndSearch
        dataFormSearchFieldImportTracking={dataFormSearchFieldImportTracking}
        setDataFormSearchFieldImportTracking={
          setDataFormSearchFieldImportTracking
        }
        setResetFormValueImportTracking={setResetFormValueImportTracking}
        resetFormValueImportTracking={resetFormValueImportTracking}
        resetFormTextImportTracking={resetFormTextImportTracking}
      />
      <Box className="carGenericOuterTableBox">
        <Box>
          <Card>
            <Box
              minHeight={46}
              pr={1}
              display="flex"
              justifyContent={"flex-end"}
              alignItems="center"
            >
              <Tooltip title={t("tooltipTitle.download")}>
                <IconButton
                  color="accent"
                  disabled={length === 0 ? true : false}
                  onClick={exportDataImportTracking}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Card>
        </Box>
        <Box>
          <AgGridOperationTable
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}
          />

        </Box>
        {loading && <CustomLoader loading={loading} />}
      </Box>
    </>
  );
};
